import { pxArrayToRem, pxToRem, type StyleRule } from '@archipro-design/aria';

export const ProductTile: StyleRule<{ draftOrPending?: boolean }> = ({
    draftOrPending: pendingOrDraft,
}) => ({
    opacity: pendingOrDraft ? 0.6 : 1,
});

export const DraftOrPendingBadge: StyleRule = ({ theme }) => ({
    zIndex: theme.siteVariables.zIndexes.overlay,
    position: 'absolute',
    color: theme.siteVariables.colors.charcoal[250],
    padding: pxArrayToRem([4, 6]),
    bottom: pxToRem(8),
    left: pxToRem(8),
    backgroundColor: theme.siteVariables.colors.white[300],
    borderRadius: pxToRem(2),
    fontSize: pxToRem(10),
});
